// apps/client/src/hooks/useCreateClientSet.ts
import { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

interface CreateClientSetRequest {
  clientSetName: string;
  customerNames: string[];
}

interface CreateClientSetResponse {
  clientSetId: string;
  loanCount: number;
  totalValueCents: number;
}

interface UseCreateClientSetReturn {
  createClientSet: (data: CreateClientSetRequest) => Promise<CreateClientSetResponse>;
  loading: boolean;
  error: string | null;
}

/**
 * Hook to create a new client set
 * Calls Cloud Function to validate and save client set
 */
export function useCreateClientSet(): UseCreateClientSetReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createClientSet = async (data: CreateClientSetRequest): Promise<CreateClientSetResponse> => {
    setLoading(true);
    setError(null);

    try {
      console.log(`[useCreateClientSet] Creating client set "${data.clientSetName}" with ${data.customerNames.length} customers`);

      const createClientSetFunc = httpsCallable<
        CreateClientSetRequest,
        CreateClientSetResponse
      >(functions, 'createClientSet');

      const result = await createClientSetFunc(data);

      console.log(`[useCreateClientSet] Created client set ${result.data.clientSetId}`);

      return result.data;
    } catch (err) {
      console.error('[useCreateClientSet] Error creating client set:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to create client set';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    createClientSet,
    loading,
    error,
  };
}
